import { Component, Input, OnInit } from '@angular/core';
import { MailValidatorService } from 'src/app/shared/services/mail-validator.service';
import { Tutor } from '../../models/tutor.model';
import { TutorService } from '../../services/tutor.service';

@Component({
    selector: 'app-tutor-edit',
    templateUrl: './tutor-edit.component.html',
    styleUrls: [ './tutor-edit.component.scss' ]
})
export class TutorEditComponent implements OnInit {

    @Input() tutor: Tutor;

    public tutorPasswordConfirmation: string;

    public isValidEmail: boolean = true;
    public emailValidationError: string;

    public isValidPassword: boolean = true;
    public isValidPasswordConfirmation: boolean = true;
    public passwordValidationError: string;
    public passwordConfirmationValidationError: string;

    public showSuccessMessage: boolean = false;
    public successMessage    : string = 'Los datos se han modificado correctamente.';
    public showErrorMessage  : boolean = false;
    public errorMessage      : string = 'Se ha producido un error al modificar los datos.'

    public isProcessing: boolean = false;

    constructor(private tutorService: TutorService, private mailValidatorService: MailValidatorService) { }

    ngOnInit() { }

    public onEmailChange() {

        if (this.tutor.mail === null && this.tutor.mail === "") {
            this.tutor.mail          = null;
            this.isValidEmail         = false;
            this.emailValidationError = null;
            return;
        }

        let emailValidation       = this.mailValidatorService.validate(this.tutor.mail);
        this.isValidEmail         = emailValidation.success;
        this.emailValidationError = this.isValidEmail ? null : emailValidation.message;

    }

    public onPasswordChange() {

        this.isValidPassword         = true;
        this.passwordValidationError = null;

        if (this.tutor.password.length > 0 && this.tutor.password.length < 6) {

            this.isValidPassword = false;
            this.passwordValidationError = 'La contraseña no puede tener menos de 6 caracteres';

        }

        this.onPasswordConfirmationChange();

    }

    public onPasswordConfirmationChange() {

        this.isValidPasswordConfirmation         = true;
        this.passwordConfirmationValidationError = null;

        if (this.tutor.password !== this.tutorPasswordConfirmation) {

            this.isValidPasswordConfirmation = false;
            this.passwordConfirmationValidationError = 'Las contraseñas no coinciden';

        }

    }

    public isFormValid() {

        let isValidDni     = this.tutor.dni && this.tutor.dni !== null && this.tutor.dni !== '';
        let isValidName    = this.tutor.name && this.tutor.name !== null && this.tutor.name !== '';
        let isValidSurname = this.tutor.surname && this.tutor.surname !== null && this.tutor.surname !== '';
        let isValidEmail   = this.tutor.mail && this.tutor.mail !== null && this.tutor.mail !== '' && this.isValidEmail;
        let isValidPhone1  = this.tutor.phone1 && this.tutor.phone1 !== null && this.tutor.phone1 !== '';

        return isValidDni && isValidName && isValidSurname &&
               isValidEmail && isValidPhone1 &&
               this.isValidPassword && this.isValidPasswordConfirmation;


    }

    public updateTutor() {

        this.resetAlerts();
        this.isProcessing = true;
        this.tutorService.update(this.tutor).subscribe({

            next: () => {this.showSuccessAlertMessage(5000);
            },

            error: (error: string) => {
                this.showErrorMessage = true;
                this.errorMessage = error;
            }

        }).add(() => {
            this.isProcessing = false;
        })


    }

    private showSuccessAlertMessage(miliseconds: number) {

        this.showSuccessMessage = true;
        setTimeout(() => {
            this.showSuccessMessage = false;
        }, miliseconds);

    }

    private resetAlerts() {

        this.showSuccessMessage = false;
        this.showErrorMessage   = false;

    }

}
